import React from 'react';
import { Empty, Button, Typography } from 'antd';
import { appDesign } from '../theme/appDesign';

const { Text } = Typography;

type EmptyStateProps = {
  description: string;
  actionLabel?: string;
  onAction?: () => void;
  style?: React.CSSProperties;
};

/** Unified empty state — mint accent, one optional CTA. */
export const EmptyState: React.FC<EmptyStateProps> = ({
  description,
  actionLabel,
  onAction,
  style,
}) => (
  <div style={{ padding: '24px 8px', textAlign: 'center', ...style }}>
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={<Text type="secondary">{description}</Text>}
    >
      {actionLabel && onAction ? (
        <Button type="primary" onClick={onAction} style={{ borderRadius: appDesign.radiusSm }}>
          {actionLabel}
        </Button>
      ) : null}
    </Empty>
  </div>
);
